import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import DashboardContext from "src/context/dashboard-context";
import { Colors } from "src/utils/data/constant";
import {
  formatNumber,
  getPortfolioTypeTranslation,
} from "src/utils/helper/functions";
import DoughnutChart from "./doughnut-chart";

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
};

const LiabilitiesCashDistribution: any = ({
  setShowCashDetails,
  setShowAssetsDetails,
  setShowFundDetails,
  selectedCashItem,
  setSelectedCashItem,
  selectedCashItemCurrency,
  setSelectedCashItemCurrency,
}) => {
  const {
    selectedAccount,
    sumOfPendingCash,
    liabilities,
    totalPayableCash,
  }: any = useContext(DashboardContext);
  const [chartData, setChartData] = useState<any>(null);
  const [selectedItemChartData, setSelectedItemChartData] = useState<any>(null);

  useEffect(() => {
    setChartData({
      labels: Object.entries(getChartByData()).map(([key, value]: any) => key),
      datasets: [
        {
          label: "",
          data: Object.entries(getChartByData()).map(([key, value]: any) =>
            (
              +(
                getSumission(value, "reportingMarketAmount") /
                (totalPayableCash + sumOfPendingCash)
              ) * 100
            )?.toFixed(1)
          ),
          backgroundColor: Colors,
          borderColor: Colors,
          borderWidth: 1,
        },
      ],
    });
  }, [liabilities]);

  const getChartByData = (): any => {
    const groupedData = liabilities
      .filter((item: any) => item.productGroupCode === "CSH")
      ?.reduce((acc: any, obj: any) => {
        const key = obj[`secNameEn`];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});
    return groupedData;
  };

  const getSumission = (data: any[], key: string): number => {
    return data?.reduce(
      (accumulator, currentValue) => accumulator + currentValue[key],
      0
    );
  };

  const onSelectItem = (item: any) => {
    setSelectedItemChartData({
      labels: Object.keys(groupedByPortfolio(item)),
      datasets: [
        {
          label: "",
          data: Object.entries(groupedByPortfolio(item)).map(
            ([key, value]: any) => getSumission(value, "reportingMarketAmount")
          ),
          backgroundColor: Colors,
          borderColor: Colors,
          borderWidth: 1,
        },
      ],
    });

    setSelectedCashItem(item);
  };

  const groupedByPortfolio = (data: any) => {
    return data.reduce((result: any, item: any) => {
      if (!result[item.portfolioCode]) {
        result[item.portfolioCode] = [];
      }
      result[item.portfolioCode].push(item);
      return result;
    }, {});
  };

  return !selectedCashItem?.length ? (
    <div
      id="csh"
      className=" slide-left p-3 md:p-4 w-full bg-white rounded-xl add-shadow flex-col justify-start items-start gap-5 inline-flex"
    >
      <div className="Frame576281 self-stretch flex-col justify-start items-center gap-3 flex">
        <div className="Frame576049 self-stretch flex-col justify-start items-start gap-5 flex">
          <div className="items-center gap-2 inline-flex w-full">
            <img
              src="/images/arrow-right.svg"
              className={clsx("cursor-pointer", "rotate-180")}
              width={24}
              height={24}
              alt="back"
              onClick={() => {
                setShowCashDetails(false);
                setShowAssetsDetails(false);
                setShowFundDetails(false);
              }}
            />
            <div className=" flex grow text-[#2a2a2a] text-sm md:text-base font-bold">
              Cash Payable
            </div>
          </div>
          <div className=" self-stretch px-3 py-4 bg-white rounded-2xl add-shadow justify-between items-start flex">
            <div className="w-full md:w-[398px] flex-col justify-center items-start gap-5 inline-flex">
              <div className=" flex-col justify-center items-start flex">
                <div className=" opacity-70 text-[#3f3f3f] text-xs md:text-sm font-semibold leading-snug">
                  Total cash payable
                </div>
                <div className=" text-[#002f6c] text-xl md:text-[32px] font-bold leading-[48px]">
                  {formatNumber(
                    totalPayableCash + Math.abs(sumOfPendingCash),
                    selectedAccount?.reportingCurrencyDcp,
                    false
                  )}
                </div>
              </div>
            </div>
            <div className="flex grow items-center justify-center h-[100px]">
              {chartData ? (
                <DoughnutChart data={chartData} options={options} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <p className="text-blue-500 font-semibold text-sm md:text-base">
        Payable distribution
      </p>
      <div className=" self-stretch  flex-col justify-start items-start gap-4 flex px-3 py-4 bg-white rounded-2xl add-shadow">
        {Object.entries(getChartByData()).map(
          ([item, value]: any, index: number) => {
            return (
              <div key={index} className="flex flex-col w-full ">
                <div className="self-stretch justify-start items-start gap-2 md:gap-4 inline-flex">
                  <div className=" rounded-[500px] justify-center items-center flex">
                    <div className="w-5 h-5 md:w-10 md:h-10 rounded-[500px] justify-center items-center flex">
                      <div
                        className={clsx(
                          " grow shrink basis-0 self-stretch  rounded-[500px]"
                        )}
                        style={{ backgroundColor: Colors[index] }}
                      />
                    </div>
                  </div>
                  <div className=" grow shrink basis-0 rounded-3xl flex-col justify-start items-start gap-2 inline-flex">
                    <div className=" self-stretch justify-between items-center inline-flex">
                      <div className=" h-[31px] justify-start items-center gap-1.5 flex">
                        <div className=" text-blue-500 text-xs md:text-sm font-bold leading-snug">
                          {item}
                        </div>
                      </div>
                      <div className=" py-1 rounded-[32px] justify-start items-center gap-1 md:gap-3 flex">
                        <div className="Label text-right text-[#002f6c] text-[10px] md:text-xs font-medium">
                          ~{" "}
                          {(
                            (getSumission(value, "reportingMarketAmount") /
                              (totalPayableCash + sumOfPendingCash)) *
                            100
                          )?.toFixed(2)}
                          %
                        </div>
                      </div>
                    </div>

                    <div className=" self-stretch justify-start items-start gap-1.5 inline-flex">
                      <div className=" grow shrink basis-0 h-[22px] opacity-70 text-[#637381] text-xs md:text-sm font-semibold leading-snug">
                        Total payable
                      </div>
                      <div className=" text-[#212b36] text-sm font-semibold leading-snug">
                        {formatNumber(
                          getSumission(value, "reportingMarketAmount"),
                          selectedAccount?.reportingCurrencyDcp,
                          false
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="cursor-pointer w-6 h-6 justify-center items-center flex"
                    onClick={() => {
                      onSelectItem(value);
                    }}
                  >
                    <img
                      src="/images/arrow-right.svg"
                      width={24}
                      height={24}
                      alt="arrow"
                      className={clsx("cursor-pointer")}
                    />
                  </div>
                </div>
              </div>
            );
          }
        )}
        <div className=" self-stretch origin-top-left rotate-90 opacity-30  rounded-[11px]" />
      </div>
    </div>
  ) : (
    <div className=" slide-left p-4 w-full bg-white rounded-xl add-shadow flex-col justify-start items-start gap-5 inline-flex">
      <div className="Frame576281 self-stretch flex-col justify-start items-center gap-3 flex">
        <div className="Frame576049 self-stretch flex-col justify-start items-start gap-5 flex">
          <div className="items-center gap-2 inline-flex w-full">
            <img
              src="/images/arrow-right.svg"
              className={clsx("cursor-pointer", "rotate-180")}
              width={24}
              height={24}
              alt="back"
              onClick={() => {
                setSelectedCashItem(null);
              }}
            />
            <div className=" flex grow text-[#2a2a2a] text-base font-bold">
              Cash Payable
            </div>
          </div>
          <div className=" self-stretch px-3 py-4 bg-white rounded-2xl add-shadow justify-between items-start inline-flex">
            <div className="w-[398px] flex-col justify-center items-start gap-5 inline-flex">
              <div className=" flex-col justify-center items-start flex">
                <div className="Totalactiveusers opacity-70 text-[#3f3f3f] text-sm font-semibold leading-snug">
                  {selectedCashItem[0][`secNameEn`]}
                </div>
                <div className="NumbershortRand text-[#002f6c] text-[32px] font-bold leading-[48px]">
                  {formatNumber(
                    getSumission(selectedCashItem, "reportingMarketAmount"),
                    selectedAccount?.reportingCurrencyDcp,
                    false
                  )}
                </div>
              </div>
            </div>
            <div className="flex grow items-center justify-center h-[100px]">
              {selectedItemChartData ? (
                <DoughnutChart data={selectedItemChartData} options={options} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <p className="text-blue-500 font-semibold">Portfolio distribution</p>
      <div className="Stack self-stretch  flex-col justify-start items-start gap-4 flex px-3 py-4 bg-white rounded-2xl add-shadow">
        {Object.entries(groupedByPortfolio(selectedCashItem)).map(
          ([key, value]: any, index) => {
            return (
              <div key={index} className="flex flex-col w-full ">
                <div className="self-stretch justify-start items-start gap-4 inline-flex">
                  <div className=" rounded-[500px] justify-center items-center flex">
                    <div className="Img w-10 h-10 rounded-[500px] justify-center items-center flex">
                      <div
                        className={clsx(
                          " grow shrink basis-0 self-stretch  rounded-[500px]"
                        )}
                        style={{ backgroundColor: Colors[index] }}
                      />
                    </div>
                  </div>
                  <div className=" grow shrink basis-0 rounded-3xl flex-col justify-start items-start gap-1.5 inline-flex">
                    <div className=" self-stretch justify-between items-center inline-flex">
                      <div className="Frame576323 h-[31px] justify-start items-center gap-1.5 flex">
                        <div className="NameRand text-blue-500 text-sm font-bold leading-snug">
                          {key}
                        </div>
                        <div className=" py-1 rounded-[32px] justify-start items-center gap-[9px] flex">
                          <div className="Label text-right text-[#002f6c] text-xs font-medium">
                            ~{" "}
                            {(
                              (getSumission(value, "reportingMarketAmount") /
                                getSumission(
                                  selectedCashItem,
                                  "reportingMarketAmount"
                                )) *
                              100
                            )?.toFixed(2)}
                            %
                          </div>
                        </div>
                      </div>
                      <div className=" text-[#212b36] text-sm font-semibold leading-snug">
                        {formatNumber(
                          getSumission(value, "reportingMarketAmount"),
                          value[0]?.reportingCurrencyDcp,
                          false
                        )}
                      </div>
                    </div>

                    <div className=" self-stretch justify-start items-start gap-1.5 inline-flex">
                      <div className=" grow shrink basis-0 h-[22px] opacity-70 text-[#637381] text-sm font-semibold leading-snug">
                        Portfolio type
                      </div>
                      <div className=" text-blue-500 text-sm font-semibold leading-snug">
                        Portfolio{" "}
                        {getPortfolioTypeTranslation(
                          value[0]?.portfolioGroupName
                            .split("Portfolio")[0]
                            ?.trim()
                        )}
                      </div>
                    </div>
                    <div className=" self-stretch justify-start items-start gap-1.5 inline-flex">
                      <div className=" grow shrink basis-0 h-[22px] opacity-70 text-[#637381] text-sm font-semibold leading-snug">
                        Portfolio currency
                      </div>
                      <div className=" text-[#212b36] text-sm font-semibold leading-snug">
                        {value[0]?.portfolioCurrency}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        )}
        <div className=" self-stretch origin-top-left rotate-90 opacity-30  rounded-[11px]" />
      </div>
    </div>
  );
};

export default LiabilitiesCashDistribution;
